import styled, { css } from 'styled-components';
import { black, inter, white } from '../../Theme';

const triangleBase = css`
    content: "";
    display: block;
    position: absolute;
    border: solid;
`;

export const HoverElement = styled.div`
    position: absolute;
    background-color: ${white};
    color: ${({ $color }) => $color || black}; 
    border-radius: 3px;
    display: ${({ $visible }) => ($visible ? "block" : "none")};
    pointer-events: none;
    border: 1px solid #E2E2EB;
    box-shadow: 0 8px 20px -2px rgba(0, 0, 0, .07);
    z-index: 1;
    padding: ${({ $padding }) => $padding || "8px 12px"};
    width: ${({ $width }) => $width || "auto"};
    white-space: ${({ $noWrap }) => ($noWrap ? "nowrap" : "normal")};

    ${({ $placement }) => $placement === 'bottom-left' && css`
        top: 16px;
        
        &:before {
            ${triangleBase};
            top: -8px;
            left: 20px;
            border-color: #E2E2EB transparent;
            border-width: 0 8px 8px 8px;
        }

        &:after {
            ${triangleBase};
            top: -7px;
            left: 19px;
            border-color: ${white} transparent;
            border-width: 0 9px 9px 9px;
        }
    `}

    ${({ $placement }) => $placement === 'top-center' && css`
        left: 50%;
        transform: translate(-50%, calc(-100% - 12px));
        
        &:before {
            ${triangleBase};
            bottom: -8px;
            left: 50%;
            transform: translateX(-50%);
            border-color: #E2E2EB transparent;
            border-width: 8px 8px 0 8px;
        }
        &:after {
            ${triangleBase};
            bottom: -7px;
            left: 50%;
            transform: translateX(-50%);
            border-color: ${white} transparent;
            border-width: 7px 7px 0 7px;
        }
    `}
`;

export const HoverElementTitle = styled.p`
    font-family: ${inter};
    font-weight: 700;
    font-size: ${({ $small }) => ($small ? "14px" : "16px")};
    margin: 0;
`;

export const HoverElementText = styled.p`
    font-family: ${inter};
    font-weight: 400;
    font-size: ${({ $small }) => ($small ? "14px" : "16px")};
    margin: 0;
    ${({ $addMarginBottom }) => $addMarginBottom && "margin-bottom: 16px;"};
`;